export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6211.a2f92d11.jpg";